import { render, staticRenderFns } from "./LoginNewPass.vue?vue&type=template&id=380e8f55&scoped=true&"
import script from "./LoginNewPass.vue?vue&type=script&lang=js&"
export * from "./LoginNewPass.vue?vue&type=script&lang=js&"
import style0 from "./LoginNewPass.vue?vue&type=style&index=0&id=380e8f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e8f55",
  null
  
)

export default component.exports